var _rect, _path, _path2, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 65,
    height: 65,
    rx: 32.5,
    fill: "#EFF8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 29.6272C22.5 27.762 24.012 26.25 25.8772 26.25C26.8463 26.25 27.7067 25.6299 28.0132 24.7105L28.125 24.375C28.1777 24.2168 28.2041 24.1377 28.2323 24.0675C28.5926 23.1714 29.4367 22.563 30.4008 22.5046C30.4763 22.5 30.5597 22.5 30.7264 22.5H39.2736C39.4403 22.5 39.5237 22.5 39.5992 22.5046C40.5633 22.563 41.4074 23.1714 41.7677 24.0675C41.7959 24.1377 41.8223 24.2168 41.875 24.375L41.9868 24.7105C42.2933 25.6299 43.1537 26.25 44.1228 26.25C45.988 26.25 47.5 27.762 47.5 29.6272V40.25C47.5 42.3502 47.5 43.4003 47.0913 44.2025C46.7317 44.9081 46.1581 45.4817 45.4525 45.8413C44.6503 46.25 43.6002 46.25 41.5 46.25H28.5C26.3998 46.25 25.3497 46.25 24.5475 45.8413C23.8419 45.4817 23.2683 44.9081 22.9087 44.2025C22.5 43.4003 22.5 42.3502 22.5 40.25V29.6272Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 40.625C38.1066 40.625 40.625 38.1066 40.625 35C40.625 31.8934 38.1066 29.375 35 29.375C31.8934 29.375 29.375 31.8934 29.375 35C29.375 38.1066 31.8934 40.625 35 40.625Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 65,
    height: 65,
    rx: 32.5,
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.55373e4bdb5697586295e13bfd7ec523.svg";
export { ForwardRef as ReactComponent };